// export const baseUrl = "https://crm.classplus.co";
export const baseUrl = "https://api.classplusapp.com";
